import { EmploymentTerminationReasonsService } from './employment-termination-reason.service';
const service = new EmploymentTerminationReasonsService();

const state = {
   employmentTerminationReasons: [],
};

const getters = {
   employmentTerminationReasons(state: any) {
      return state.employmentTerminationReasons;
   },
};

const mutations = {
   SET_EMPLOYMENT_TERMINATION_REASONS(state: any, reasons: any) {
      state.employmentTerminationReasons = reasons;
   },
};

const actions = {
   async getEmploymentTerminationReasons({ commit }: any) {
      return await service.getEmploymentTerminationReasons().then((reasons) => {
         commit('SET_EMPLOYMENT_TERMINATION_REASONS', reasons);
         return reasons;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
